export default (html: string) => {
  let tmp = document.createElement('DIV');

  tmp.innerHTML = html;

  return tmp.textContent || tmp.innerText || '';
};
